/* Copyright (c) 2017 Backpack Health LLC */

import superagent from 'superagent';
import { authToken } from '../utilities/LocalStorage';
import AppUtils from '../utilities/AppUtils';
import { alertOfflineMode, isMobileOffline } from '../utilities/MobileUtil';
import { appManifest } from '../utilities/appManifest';

const HOST = API_BASE_URL;
const API_VERSION = 'v1';
const UNAUTHORIZED_STATUS_CODE = 401;

function getBaseUrl() {
  return `${HOST}/api/${API_VERSION}`;
}

function logOutIfUnauthorized(err) {
  if (err.status === UNAUTHORIZED_STATUS_CODE) {
    AppUtils.logout({}, AppUtils.reloadApp);
  }
}

function authorizedApiRequestBlob(restVerb, url, errorHandler = logOutIfUnauthorized) {
  return authorizedApiRequest(restVerb, url, errorHandler)
    .responseType('blob');
}

function authorizedApiRequest(restVerb, url, errorHandler = logOutIfUnauthorized) {
  return authorizedApiRequestWithFullUrl(restVerb, `${getBaseUrl()}/${url}`, errorHandler);
}

function authorizedApiRequestV2(restVerb, url, errorHandler = logOutIfUnauthorized) {
  return authorizedApiRequestWithFullUrl(restVerb, `${HOST}/api/v2/${url}`, errorHandler);
}

function authorizedApiRequestWithFullUrl(restVerb, url, errorHandler = logOutIfUnauthorized) {
  const token = authToken.get();
  if (restVerb !== 'get' && isMobileOffline()) {
    alertOfflineMode();
  }
  if (restVerb === 'get' && AppUtils.isIE11()) {
    url = `${url}${url.indexOf('?') >= 0 ? '&' : '?'}resetCache=${Math.random()}`;
  }
  return callSuperagent(restVerb, url, token)
    .on('error', errorHandler);
}

function apiRequest(restVerb, url) {
  if (restVerb !== 'get' && isMobileOffline()) {
    alertOfflineMode();
  }
  return callSuperagent(restVerb, `${getBaseUrl()}/${url}`);
}

function headRequest(url) {
  if (isMobileOffline()) {
    alertOfflineMode();
  }
  return callSuperagent('head', url);
}

function externalApi(restVerb, url) {
  if (restVerb !== 'get' && isMobileOffline()) {
    alertOfflineMode();
  }
  return superagent(restVerb, url);
}

function callSuperagent(method, url, auth = undefined) {
  return superagent(method, url)
    .set({
      Authorization: auth ? `Bearer ${auth}` : undefined,
      'X-Backpack-Client-Context': 'backpack',
      'X-Backpack-Client-Version': appManifest.app_version,
    });
}

export {
  apiRequest,
  authorizedApiRequest,
  authorizedApiRequestV2,
  authorizedApiRequestBlob,
  authorizedApiRequestWithFullUrl,
  externalApi,
  headRequest,
  getBaseUrl,
};
